import React from "react";

import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { HelpBox } from "@/components/atoms";
import { toRounded } from "@/utils";

interface SearchBoxProps {
  name: string;
  value: number;
  valueFormatter?: (value: number) => number | string;
  icon?: React.ReactNode;
  size?: "small" | "medium";
}

const MiniStatBox: React.FC<SearchBoxProps> = ({
  name,
  value,
  valueFormatter = toRounded,
  icon,
  size = "medium"
}) => {
  const theme = useTheme();

  return (
    <HelpBox title={name}>
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        border={1}
        borderRadius={1}
        borderColor={theme.palette.divider}
        p={size === "small" ? 0.5 : 1}
        minWidth={size === "small" ? "100px": "120px"}
        height={size === "small" ? "40px" : "50px"}
      >
        {icon}
        <Typography variant={size === "small" ? "body1" : "h6"}>
          {valueFormatter(value)}
        </Typography>
      </Stack>
    </HelpBox>
  );
};

export default MiniStatBox;
